<div class="custom-snackbar">
    <div class="closeCut" (click)="dismiss()">
        <img src="assets/images/close.svg" alt="">
    </div>
    <div class="msgbody">
        <img src="{{!showIcon ?'assets/images/checkmark.svg':'assets/images/exclamation.png'}}" alt="">
        <span class="msgtxt {{showIcon ?'text-danger':''}}">{{ message }}</span>
    </div>
</div>